import { toast } from 'sonner';

export async function downloadPdf(url, headers, filename) {
  try {
    const res = await fetch(url, { headers });
    if (!res.ok) throw new Error('Download failed');
    const blob = await res.blob();
    const href = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch (err) { toast.error(err.message); }
}
